export const selectProjectBySlug = (projects, slug) => {
  const projectId = projects.ids.find((id) => projects.hash[id].slug === slug);
  return projects.hash[projectId];
};
